import { createSelector } from '@reduxjs/toolkit';

import { getFilters } from './getFilters';

export const getApartmentsWithDecoration = createSelector(getFilters, state => state.apartmentsWithDecoration);
